import React from 'react';
import Table from '../../../common/Table';
import { numberFormatter } from '../../../../utils/number';
import {
  getPaymentMethodNameByType,
  TRANSACTION_TYPE_CREDIT_CARD,
  TRANSACTION_TYPE_INTERNET,
} from '../../../../config/constants';

const SalesByPaymentMethodSummary = ({
  totalIncomesForPaymentMethodList,
  isOrderDesc,
}) => {
  const transformedData = totalIncomesForPaymentMethodList.map((item) => {
    if (item.transactionCode === TRANSACTION_TYPE_INTERNET) {
      return { ...item, transactionCode: TRANSACTION_TYPE_CREDIT_CARD };
    }
    return item;
  });

  const groupedData = Object.values(
    transformedData.reduce((acc, curr) => {
      const code = curr.transactionCode;
      if (!acc[code]) {
        acc[code] = { ...curr };
      } else {
        acc[code].totalAmount += curr.totalAmount;
      }
      return acc;
    }, {}),
  );

  const alphabeticalOrder = (data) =>
    data.sort((a, b) => {
      const nameA = getPaymentMethodNameByType(a.transactionCode).toUpperCase();
      const nameB = getPaymentMethodNameByType(b.transactionCode).toUpperCase();
      if (nameA < nameB) {
        return isOrderDesc ? 1 : -1;
      }
      if (nameA > nameB) {
        return isOrderDesc ? -1 : 1;
      }
      return 0;
    });
  const orderedGroupedData = alphabeticalOrder(groupedData);

  return (
    <>
      <hr />
      <h2>Resumen de Ventas</h2>
      <Table
        columns={[
          {
            Header: 'Método de Pago',
            accessor: 'transactionCode',
            className: 'text-center',
            Cell: ({ value }) => {
              return getPaymentMethodNameByType(value);
            },
          },
          {
            Header: 'Total',
            accessor: 'totalAmount',
            Cell: ({ value }) => numberFormatter({ value }),
            Footer: (row) =>
              `Total: ${numberFormatter({
                value: row.data.reduce(
                  (accumulated, data) => accumulated + data.totalAmount,
                  0,
                ),
              })}`,
            className: 'text-right',
          },
        ]}
        data={orderedGroupedData}
        defaultPageSize={orderedGroupedData.length}
        showPagination={false}
      />
    </>
  );
};

export default SalesByPaymentMethodSummary;
